module.exports = __webpack_public_path__ + "static/media/inx_slope_grad.080de490.svg";